import { useState, React } from "react";
import { defaultTheme } from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";
import { callApi } from "@/lib/apiClient/api";
import { defaultStyles } from "./AutocompleteInput";
import { DEFAULT_PAGINATION_LIMIT } from "./ReactSelect";

const { colors } = defaultTheme;

const selectStyles = {
  control: (base, state) => ({
    ...base,
    ...defaultStyles.control(base, state),
    minWidth: 240,
    margin: 8
  }),
  menu: (provided) => ({
    ...provided,
    width: 256,
    marginLeft: -8,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
    //boxShadow: "offset 0 1px 0 rgba(0, 0, 0, 0.1)"
  }),
  valueContainer: (base) => ({
    ...defaultStyles.valueContainer(base)
  }),
  input: (base) => ({
    ...defaultStyles.input(base)
  })
};

const defaultMapResponse = (val) => ({
  label: val.name,
  value: val["@id"]
});

const Popout = ({
  resource,
  label,
  onValueChange,
  value,
  mapResponse,
  customComponents
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // maybe unite with loadOptions in React Select after refactoring there, also the hasMore calculation is little buggy
  const loadOptions = async (search, loadedOptions, { page }) => {
    let apiCallParams = { limit: DEFAULT_PAGINATION_LIMIT, page };

    if (search) {
      apiCallParams = {
        name: search, // keep in mind this "name" will work for now with categories and channels, but for other entities we might need to parametize it as in Autocomplete
        limit: DEFAULT_PAGINATION_LIMIT,
        page,
        ...apiCallParams
      };
    }
    const response = await callApi({
      url: "/" + resource,
      params: apiCallParams
    });

    const mappedOptions = response.data["hydra:member"].map(
      mapResponse ? mapResponse : defaultMapResponse
    );

    return {
      options: mappedOptions,
      hasMore: mappedOptions.length === DEFAULT_PAGINATION_LIMIT,
      additional: {
        page: page + 1
      }
    };
  };

  return (
    <Dropdown
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      target={
        <div
          role="button"
          onClick={() => setIsOpen((prev) => !prev)}
          className={`py-1 ps-2 d-flex align-items-center rounded popout ${
            (isOpen || value) && "popout-active"
          }`}
        >
          <div>{value ? `${label}: ${value.label}` : `Filter by ${label}`}</div>
          <div
            className="px-2"
            role="button"
            onClick={() => value && onValueChange(null)}
          >
            <i className={`fa-solid ${value ? "fa-xmark" : "fa-caret-down"}`} />
          </div>
        </div>
      }
    >
      <AsyncPaginate
        loadOptions={loadOptions}
        additional={{
          page: 1
        }}
        autoFocus
        backspaceRemovesValue={false}
        components={{
          DropdownIndicator,
          IndicatorSeparator: null,
          ...customComponents
        }}
        controlShouldRenderValue={false}
        hideSelectedOptions={false}
        menuShouldScrollIntoView={false}
        isClearable={false}
        menuIsOpen
        menuPosition={"fixed"}
        onChange={(newValue) => {
          onValueChange(newValue);
          setIsOpen(false);
        }}
        placeholder="Search..."
        styles={selectStyles}
        tabSelectsValue={false}
        value={value}
      />
    </Dropdown>
  );
};

const Dropdown = ({ children, isOpen, target, onClose }) => (
  <div className="mt-2 position-relative popout-container">
    {target}
    {isOpen ? <Menu>{children}</Menu> : null}
    {isOpen ? <Blanket onClick={onClose} /> : null}
  </div>
);
const Menu = (props) => {
  const shadow = "hsla(218, 50%, 10%, 0.1)";
  return (
    <div
      style={{
        backgroundColor: "white",
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
        marginTop: 8,
        position: "fixed",
        zIndex: 2
      }}
      {...props}
    />
  );
};
const Blanket = (props) => (
  <div
    style={{
      bottom: 0,
      left: 0,
      top: 0,
      right: 0,
      position: "fixed",
      zIndex: 1
    }}
    {...props}
  />
);
const Svg = (p) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    focusable="false"
    role="presentation"
    {...p}
  />
);
const DropdownIndicator = () => (
  <div style={{ color: colors.neutral20, height: 24, width: 32 }}>
    <Svg>
      <path
        d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </Svg>
  </div>
);

export default Popout;
